import React, { useEffect } from 'react';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import VideoForm from './VideoForm';
import Districtcommitie from './Districtcommitie';
import AddCause from './AddCause';
import DeleteCause from './DeleteCause';
import VideoDelete from './VideoDelete ';
import AddOfficeBearer from './BackendUploades/AddOfficeBearer';
import UpdateOfficeBearer from './BackendUploades/UpdateOfficeBearer ';
import DistrictCommitteeAddForm from './BackendUploades/DistrictCommitteeAddForm ';
import DistrictCommitteeManage from './BackendUploades/DistrictCommitteeManage';
import MasjidForm from './BackendUploades/MasjidForm';
import MasjidList from './BackendUploades/MasjidList';
import EventFormAndList from './BackendUploades/EventFormAndList';
import ManageEvents from './BackendUploades/ManageEvents';
import DonationsAdminPage from './DonationsAdminPage';
import AdminBrochures from './BackendUploades/AdminBrochures';

function AdminDashboard() {
  const navigate = useNavigate();

  // Validate dashboard access
  const DashboardValid = async () => {
    const token = localStorage.getItem("usertoken");

    try {
      const res = await fetch(`${process.env.REACT_APP_REQUESTING_API}/validation`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      if (res.status === 401 || res.status === 403) {
        console.error("Unauthorized, redirecting to login.");
        navigate("/adminlogin");
      }
    } catch (error) {
      console.error("Error during validation:", error);
      navigate("/adminlogin");
    }
  };

  useEffect(() => {
    DashboardValid();
  }, []);

  // Logout user
  const logoutUser = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_REQUESTING_API}/api/admin/logout`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('usertoken')}`,
        },
      });

      if (response.ok) {
        localStorage.removeItem('usertoken');
        navigate('/');
      } else {
        console.error('Logout request failed:', response.statusText);
      }
    } catch (error) {
      console.error('Logout request failed:', error);
    }
  };

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Sidebar */}
      <aside className="w-72 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white flex flex-col shadow-2xl">
        {/* Header */}
        <div className="p-6 bg-black/30 backdrop-blur-sm">
          <h1 className="text-2xl font-black text-center uppercase tracking-wider">Admin Panel</h1>
          <div className="w-16 h-1 bg-white mx-auto mt-3"></div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-6 px-4 space-y-2">
          {/* Causes Section */}
          <div className="mb-4">
            <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2 px-3">Causes</p>
            <Link to="addcause">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-emerald-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group">
                <span className="w-8 h-8 bg-emerald-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </span>
                Add Cause
              </button>
            </Link>
            <Link to="delete">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-red-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group mt-2">
                <span className="w-8 h-8 bg-red-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </span>
                Manage Causes
              </button>
            </Link>
          </div>

          {/* Events Section */}
          <div className="mb-4">
            <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2 px-3">Events</p>
            <Link to="events">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-blue-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group">
                <span className="w-8 h-8 bg-blue-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </span>
                Add Event
              </button>
            </Link>
            <Link to="manageevents">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-blue-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group mt-2">
                <span className="w-8 h-8 bg-blue-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </span>
                Manage Events
              </button>
            </Link>
          </div>
            {/* Events Section */}
          <div className="mb-4">
            <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2 px-3">Brochures</p>
            <Link to="brouchers">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-gray-400 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group">
                <span className="w-8 h-8 bg-gray-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </span>
                 Manage Brochures
              </button>
            </Link>
          
          </div>

          {/* Masjids Section */}
          <div className="mb-4">
            <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2 px-3">Masjids</p>
            <Link to="addmasjid">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-purple-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group">
                <span className="w-8 h-8 bg-purple-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </span>
                Add Masjid
              </button>
            </Link>
            <Link to="updatedelmasjid">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-purple-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group mt-2">
                <span className="w-8 h-8 bg-purple-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
                  </svg>
                </span>
                Manage Masjids
              </button>
            </Link>
          </div>

          {/* Office Bearers Section */}
          <div className="mb-4">
            <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2 px-3">Office Bearers</p>
            <Link to="addofficebearers">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-amber-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group">
                <span className="w-8 h-8 bg-amber-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                  </svg>
                </span>
                Add Bearer
              </button>
            </Link>
            <Link to="UpdateDelofficebearers">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-amber-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group mt-2">
                <span className="w-8 h-8 bg-amber-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </span>
                Manage Bearers
              </button>
            </Link>
          </div>

          {/* Committee Section */}
          <div className="mb-4">
            <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2 px-3">District Committee</p>
            <Link to="addcommiteemembers">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-teal-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group">
                <span className="w-8 h-8 bg-teal-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </span>
                Add Member
              </button>
            </Link>
            <Link to="updatedelcommiteemembers">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-teal-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group mt-2">
                <span className="w-8 h-8 bg-teal-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </span>
                Manage Members
              </button>
            </Link>
          </div>

          {/* Transactions Section */}
          {/* <div className="mb-4">
            <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2 px-3">Donations</p>
            <Link to="transactions">
              <button className="w-full p-3.5 bg-gray-700/50 hover:bg-green-600 rounded-xl text-left font-black text-sm transition-all duration-300 hover:translate-x-1 hover:shadow-lg flex items-center gap-3 group">
                <span className="w-8 h-8 bg-green-600 group-hover:bg-white rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4 text-white group-hover:text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </span>
                Transactions
              </button>
            </Link>
          </div> */}
        </nav>

        {/* Logout Button */}
        <button
          className="m-4 p-4 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-black text-base rounded-xl transition-all duration-300 hover:shadow-xl flex items-center justify-center gap-3 group"
          onClick={logoutUser}
        >
          <svg className="w-5 h-5 group-hover:rotate-12 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          LOGOUT
        </button>
      </aside>

      {/* Main content */}
      <div className="flex-1 p-6 md:p-8 lg:p-10 overflow-y-auto bg-gray-50">
        <main className="max-w-7xl mx-auto">
          <Routes>
            <Route path="uploadblogs" element={<VideoForm />} />
            <Route path="deletevideo" element={<VideoDelete />} />
            <Route path="districtcommities" element={<Districtcommitie />} />
            <Route path="addcause" element={<AddCause />} />
            <Route path="addmasjid" element={<MasjidForm />} />
            <Route path="updatedelmasjid" element={<MasjidList />} />
            <Route path="events" element={<EventFormAndList />} />
            <Route path="manageevents" element={<ManageEvents />} />
            <Route path="brouchers" element={<AdminBrochures />} />

            <Route path="transactions" element={<DonationsAdminPage />} />
            <Route path="addofficebearers" element={<AddOfficeBearer />} />
            <Route path="UpdateDelofficebearers" element={<UpdateOfficeBearer />} />
            <Route path="addcommiteemembers" element={<DistrictCommitteeAddForm />} />
            <Route path="updatedelcommiteemembers" element={<DistrictCommitteeManage />} />
            <Route path="delete" element={<DeleteCause />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;




// working 15/12/25

// import React, { useEffect } from 'react';
// import { Link, Route, Routes, useNavigate } from 'react-router-dom';
// import VideoForm from './VideoForm';
// import Districtcommitie from './Districtcommitie';
// import AddCause from './AddCause';
// import DeleteCause from './DeleteCause';
// import VideoDelete from './VideoDelete ';
// import AddOfficeBearer from './BackendUploades/AddOfficeBearer';
// import UpdateOfficeBearer from './BackendUploades/UpdateOfficeBearer ';
// import DistrictCommitteeAddForm from './BackendUploades/DistrictCommitteeAddForm ';
// import DistrictCommitteeManage from './BackendUploades/DistrictCommitteeManage';
// import MasjidForm from './BackendUploades/MasjidForm';
// import MasjidList from './BackendUploades/MasjidList';
// import EventFormAndList from './BackendUploades/EventFormAndList';
// import ManageEvents from './BackendUploades/ManageEvents';
// import DonationsAdminPage from './DonationsAdminPage';

// function AdminDashboard() {
//   const navigate = useNavigate();

//   // Validate dashboard access
//   const DashboardValid = async () => {
//     const token = localStorage.getItem("usertoken");

//     try {
//       const res = await fetch(`${process.env.REACT_APP_REQUESTING_API}/validation`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//       });

//       if (res.status === 401 || res.status === 403) {
//         console.error("Unauthorized, redirecting to login.");
//         navigate("/adminlogin");
//       }
//     } catch (error) {
//       console.error("Error during validation:", error);
//       navigate("/adminlogin");
//     }
//   };

//   useEffect(() => {
//     DashboardValid();
//   }, []);

//   // Logout user
//   const logoutUser = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_REQUESTING_API}/api/admin/logout`, {
//         method: 'GET',
//         credentials: 'include',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('usertoken')}`,
//         },
//       });

//       if (response.ok) {
//         localStorage.removeItem('usertoken');
//         navigate('/'); // Redirect to home after logout
//       } else {
//         console.error('Logout request failed:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Logout request failed:', error);
//     }
//   };

//   return (
//     <div className="min-h-screen flex">
//       {/* Sidebar */}
//       <aside className="w-64 bg-gray-800 text-white flex flex-col">
//         <div className="p-6 text-xl font-bold bg-gray-900 text-center">Admin Panel</div>
//         <nav className="flex-1">
//           <ul className='px-4'>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="addcause">Add Causes</Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="delete">Delete Causes</Link>
//             </li>
//             {/* <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="uploadblogs">Add Youtube Videos</Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="deletevideo">Delete Youtube Videos</Link>
//             </li> */}
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="events">Add Events</Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="manageevents">Update & Delete Events</Link>
//             </li>
            
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="addmasjid">Add Masjid </Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="updatedelmasjid">Update & Delete Masjid </Link>
//             </li>
            
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="addofficebearers"> Add Office Bearer</Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="UpdateDelofficebearers"> Update & Delete Office Bearer</Link>
//             </li>
            
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="addcommiteemembers"> Add Committee members</Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="updatedelcommiteemembers"> update & delete Committee </Link>
//             </li>

//              <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="transactions"> transactions </Link>
//             </li>
//             {/* <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="ourmasajids">Update or Delete Causes</Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="">Add Donators Info</Link>
//             </li>
//             <li className="p-4 bg-gray-700  hover:bg-gray-500  mb-4 text-center">
//               <Link to="">Delete Donators Info</Link>
//             </li> */}
//           </ul>
//         </nav>
//         <button
//           className="p-4  bg-red-500 hover:bg-red-600 text-white font-thin text-lg w-full"
//           onClick={logoutUser}
//         >
//           Logout
//         </button>
//       </aside>

//       {/* Main content */}
//       <div className="flex-1 p-8">
//         <main>
//           <Routes>
//             <Route path="uploadblogs" element={<VideoForm />} />
//             <Route path="deletevideo" element={<VideoDelete />} />
//             {/* <Route path="ourmasajids" element={<Masajids />} /> */}
//             <Route path="districtcommities" element={<Districtcommitie />} />
//             <Route path="addcause" element={<AddCause />} />
//             <Route path="addmasjid" element={<MasjidForm />} />
//             <Route path="updatedelmasjid" element={<MasjidList />} />
//             <Route path="events" element={<EventFormAndList />} />
//             <Route path="manageevents" element={<ManageEvents />} />

//             <Route path="transactions" element={<DonationsAdminPage />} />
            
//             <Route path="addofficebearers" element={<AddOfficeBearer />} />
//             <Route path="UpdateDelofficebearers" element={<UpdateOfficeBearer />} />
//             <Route path="addcommiteemembers" element={<DistrictCommitteeAddForm />} />
//             <Route path="updatedelcommiteemembers" element={<DistrictCommitteeManage />} />


            

//             <Route path="delete" element={<DeleteCause />} />
//           </Routes>
//         </main>
//       </div>
//     </div>
//   );
// }

// export default AdminDashboard;



